export default class AbortControllerWithParent {
  private controller: AbortController;
  public signal: AbortSignal;

  constructor(parent?: AbortSignal) {
    this.controller = new AbortController();
    this.signal = this.controller.signal;

    if (parent?.aborted) {
      this.controller.abort();
    } else if (parent) {
      parent.addEventListener("abort", () => this.controller.abort(), { once: true });
    }
  }

  abort() {
    this.controller.abort();
  }
}